// import { Component, signal } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
// import { Header } from './shared/header/header';
// import { Header1 } from './shared/header-1/header-1';
// import { Footer } from './shared/footer/footer';
// import { filter } from 'rxjs/operators';

// @Component({
//   selector: 'app-root',
//   imports: [CommonModule, RouterOutlet, Header, Header1, Footer],
//   templateUrl: './app.html',
//   styleUrl: './app.scss'
// })
// export class App {
//   protected readonly title = signal('autoverse');

//   showDefaultHeader = true;
//   showHeader1 = false;

//   constructor(private router: Router) {
//     this.router.events.pipe(
//       filter(event => event instanceof NavigationEnd)
//     ).subscribe((event: NavigationEnd) => {
//       const url = event.urlAfterRedirects;

//       this.showDefaultHeader = (!url.startsWith('/supplier-network') && !url.startsWith('/registration-decode') && !url.startsWith('/make') && !url.startsWith('/model')&& !url.startsWith('/year')&& !url.startsWith('/model')&& !url.startsWith('/variant')&& !url.startsWith('/model')&& !url.startsWith('/estimate-list')&& !url.startsWith('/estimate-details')&& !url.startsWith('/estimate-details-download'));
//       this.showHeader1 = url.startsWith('/supplier-network');
//     });
//   }

// }


import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Header } from './shared/header/header';
import { Header1 } from './shared/header-1/header-1';
import { Footer } from './shared/footer/footer';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [CommonModule, RouterOutlet, Header, Header1, Footer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('autoverse');

  showDefaultHeader = true;
  showHeader1 = false;

  constructor(private router: Router) {

    // 👇 PUT THE CODE RIGHT HERE
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        const isGarageDetails = url.startsWith('/garage-details');

        this.showDefaultHeader = (
          !isGarageDetails &&
          !url.startsWith('/supplier-network') &&
          !url.startsWith('/registration-decode') &&
          !url.startsWith('/make') &&
          !url.startsWith('/model') &&
          !url.startsWith('/year') &&
          !url.startsWith('/variant') &&
          !url.startsWith('/estimate-list') &&
          !url.startsWith('/estimate-details') &&
          !url.startsWith('/estimate-details-download') &&
          !url.startsWith('/periodic-service-details') &&
          !url.startsWith('/steering-issue-details') &&
          !url.startsWith('/tyre-issue-details') &&
          !url.startsWith('/ac-not-colling-details') &&
          !url.startsWith('/brake-noise-details.html') &&
          !url.startsWith('/car-not-starting-details') &&
          !url.startsWith('/denting-and-painting-details') &&
          !url.startsWith('/engine-noise-details.html')
        );

        this.showHeader1 = url.startsWith('/supplier-network');

        // 🔥 IMPORTANT: removes top spacing
        document.body.classList.toggle('no-global-header', isGarageDetails);
      });
  }
}
